/**
 * 简单类型选择器, 可以直接跟form一起工作而不需要被Form.Item包裹
 * # 注意: 选择时会自动提交表单
 * @label 类型名
 * @labelWidth 类型名所占宽度, 因为有些类型名很长
 * @tagData 类别列表 {key: "xxx", label: "2020届"}
 * @multiple 单选还是多选
 *
 * @defaultValue 默认选择 默认选择""即全部
 * @onChange 变更时触发
 */
import React, {useContext} from 'react';
import FormFilterInner, {
    FormFilterInnerProps,
    ValueType,
} from './FormFilterInner';
import {Form} from 'antd';
import {ProFormContext} from '../../context';
import {NamePath} from 'rc-field-form/lib/interface';

export interface FormFilterProps<T extends ValueType>
    extends Omit<FormFilterInnerProps<T>, 'value'> {
    name?: NamePath;
    preserve?: boolean; // 当字段被删除时保留字段值
}

export default function FormFilter<T extends ValueType>({
    name,
    defaultValue,
    preserve = true,
    ...innerProps
}: FormFilterProps<T>) {
    const {form} = useContext(ProFormContext);

    function onChange(val: T) {
        form?.submit();
        innerProps.onChange?.(val);
    }

    return (
        <Form.Item
            name={name}
            noStyle
            initialValue={defaultValue}
            preserve={preserve}>
            <FormFilterInner {...innerProps} onChange={onChange} />
        </Form.Item>
    );
}
